module.exports = require('./dist/lib/app')



//////////////////
// WEBPACK FOOTER
// ../node_modules/next/app.js
// module id = ../node_modules/next/app.js
// module chunks = 3